module.exports = __webpack_public_path__ + "static/media/urlConnection.9878be22.svg";